import * as React from "react"
import { SelectSeeker } from "ui-seeker/core"

const OPTIONS = [
    { label: 'Lowest rate', value: '1' },
    { label: 'Flexible rate', value: '2' },
]

export default function SelectPriceType({...props}) {

    const myProps = {
        placeholder: 'Select type', 
        firstSelect: true, 
        options: OPTIONS,
        icon: {icon: 'chart-line'},
        ...props
    }

    return <SelectSeeker {...myProps} />
}